import React from "react";
import { useTheme } from "@emotion/react";
import { BackArrow, CloseIcon } from "@bale/ui";
import {
  useBreakPoints,
  Breakpoints,
} from "components/context/BreakPointContext";
import { strings } from "intl/fa";
import classNames from "classnames";
import styles from "./Header.module.scss";
import { AccountType } from "../../../core/auth/auth.entity";

export enum NavType {
  back = 1,
  close,
  both,
}

export interface HeaderProps {
  title: string;
  className?: string;
  navType?: NavType;
  onClose?: () => void;
  onBack?: () => void;
  userType?: AccountType;
}

const Header: React.FC<React.PropsWithChildren<HeaderProps>> = (props) => {
  const theme = useTheme();
  const breakpoint = useBreakPoints();
  const Back = (
    <BackArrow
      className={styles.BackIcon}
      size={22}
      color={theme.colors.dark[400]}
      onClick={props.onBack ?? props.onClose}
    />
  );
  const Close = (
    <CloseIcon
      size={24}
      color={theme.colors.dark[300]}
      className={styles.CloseIcon}
      onClick={props.onClose}
    />
  );
  return (
    <div
      className={classNames(
        styles.Container,
        {
          [styles.hasNavIcon]: props.navType,
        },
        props.className
      )}
    >
      <p className={styles.Title}>{props.title}</p>
      {props.navType === NavType.back && Back}
      {props.navType === NavType.close && Close}
      {props.navType === NavType.both &&
        (breakpoint <= Breakpoints.Small ? Back : Close)}
      {props.userType && (
        <div className={styles.userType}>
          {strings.register.userType.title}
          <p>
            {props.userType === AccountType.Personal
              ? strings.register.userType.natural
              : strings.register.userType.legal}
          </p>
        </div>
      )}
    </div>
  );
};

export default Header;
